import React from 'react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, LanguageCode } from '../../lib/i18n';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentCode = (i18n.language || 'tr').slice(0, 2);
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === currentCode) || SUPPORTED_LANGUAGES[0];

  const menu = (
    <Menu
      selectedKeys={[current.code]}
      onClick={({ key }) => i18n.changeLanguage(key as LanguageCode)}
      items={SUPPORTED_LANGUAGES.map((lang) => ({
        key: lang.code,
        label: lang.label,
      }))}
    />
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      {/* Görünür metin ("TR") erişilebilir ada dahil olmalı (label-content-name-mismatch) */}
      <button
        type="button"
        className="lang-switcher"
        aria-label={`${current.code.toUpperCase()} — ${current.label}`}
      >
        {current.code.toUpperCase()}
        <DownOutlined className="lang-switcher__caret" />
      </button>
    </Dropdown>
  );
}
